import React from "react";
import { Reveal } from "../hooks/useReveal";
import { whoWeServe } from "../data/siteContent";

const WhoWeServe = () => {
  return (
    <section className="bg-ink py-24 sm:py-36" data-testid="who-we-serve-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
            <span className="h-px w-10 bg-gold/60" />
            Who We Serve
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-cream tracking-tight leading-[1.06] mt-6">
            This Is For You <em className="text-gold italic">If...</em>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mt-14 sm:mt-20">
          {whoWeServe.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 60}>
              <div
                className="group relative rounded-2xl overflow-hidden h-80 sm:h-96 border border-white/8"
                data-testid={`serve-card-${idx}`}
              >
                <img
                  alt={item.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  src={item.image}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-7">
                  <span className="block h-0.5 w-8 bg-gold mb-4 group-hover:w-14 transition-[width] duration-500" />
                  <h3 className="font-display text-xl sm:text-2xl text-cream">{item.title}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
